module.exports = __webpack_public_path__ + "media/images/datepicker_prev-b5705d0692dce0d2e406d91cd2e0e4b9.svg";